import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Grid } from '@mui/material'
import { makeStyles } from '@mui/styles'
import {
  type BasePuiDialogProps,
  type Nil,
  PuiDialog,
  Text,
} from '@pbt/pbt-ui-components'

import { linkUnappliedPayment } from '~/store/actions/payments'
import { getFinanceIsLoading } from '~/store/reducers/finance'
import useCloseAfterCreation from '~/utils/useCloseAfterCreation'

import PaymentInvoiceSelection from './PaymentInvoiceSelection'

const useStyles = makeStyles(
  (theme) => ({
    paper: {
      width: 650,
      maxWidth: 650,
    },
    header: {
      borderBottom: theme.constants.tabBorder,
    },
  }),
  { name: 'ApplyPaymentToInvoiceDialog' },
)

interface ApplyPaymentToInvoiceDialogProps extends BasePuiDialogProps {
  clientId: string | Nil
  paymentAmount: number
  paymentId: string
}

const ApplyPaymentToInvoiceDialog = ({
  open,
  onClose,
  paymentId,
  paymentAmount,
  clientId,
}: ApplyPaymentToInvoiceDialogProps) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const isLoading = useSelector(getFinanceIsLoading)
  const { t } = useTranslation(['Common', 'Dialogs'])

  const [invoiceIds, setInvoiceIds] = useState<string[]>([])

  const setCloseAfterAppliedOn = useCloseAfterCreation(
    onClose,
    getFinanceIsLoading,
  )

  const onContinue = () => {
    setCloseAfterAppliedOn()
    dispatch(linkUnappliedPayment(invoiceIds, paymentId))
  }

  return (
    <PuiDialog
      aria-labelledby="apply-payment-to-invoice-dialog"
      classes={{
        paper: classes.paper,
      }}
      open={open}
      onClose={onClose}
    >
      <Grid item className={classes.header} pb={1} pt={3} px={3}>
        <Text variant="h2">
          {t('Dialogs:APPLY_PAYMENT_TO_INVOICE_DIALOG.HEADER_TEXT')}
        </Text>
      </Grid>
      <PaymentInvoiceSelection
        canEditAmount={false}
        clientId={clientId}
        continueButtonText={t('Common:FINISH_ACTION')}
        invoiceIds={invoiceIds}
        isLoading={isLoading}
        paymentAmount={paymentAmount}
        setInvoiceIds={setInvoiceIds}
        onContinue={onContinue}
      />
    </PuiDialog>
  )
}

export default ApplyPaymentToInvoiceDialog
